export const serverApi = 'https://api.innerlogic.com';
export const staginApi = 'https://stg-api.innerlogic.ca';
export const localApi = 'http://127.0.0.1:8000';
// Publishable key
export const StripeKey = 'pk_test_bowWtykmtAwZxvD0bvdXEycG00LczLxeDB';
export const currentApi = serverApi;
export const SentryDSN_DEV = '';
export const SentryDSN_PROD = '';
export const SentryDSN_STG = '';
export const Environment = 'Production';

// 'https://survey-chat-v2.innerlogic-api.com/api/v1/survey-ai/generate-chat-gpt-response'
export const surveyAiApi = 'https://survey-chat-v2.innerlogic-api.com/api/v1/survey-ai'

export const config = {
  loginapi: `${currentApi}/api/account`,
  authapi: `${currentApi}/api/rest-auth`,
  surveyapi: `${currentApi}/api/survey`,
  surveyAiApi: `${surveyAiApi}`,
  appapi: `${currentApi}/api/organization`,
  website: `${currentApi}/api/web`,
};
export default config;

